import { render } from "./AppItemWrapper.vue?vue&type=template&id=3e16baf7&scoped=true&ts=true"
import script from "./AppItemWrapper.vue?vue&type=script&lang=ts"
export * from "./AppItemWrapper.vue?vue&type=script&lang=ts"

import "./AppItemWrapper.vue?vue&type=style&index=0&id=3e16baf7&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e16baf7"]])

export default __exports__